export default "__VITE_ASSET__Pm4GV4No__"